import { Typography } from '@mui/material';
import { AirQualityTable } from '../Components/AirQuality/AirQualityTable';
import { Page } from '@perry-weather/component-library';
import { useAirQualitySensorsQuery } from '../Services/API';
import Unauthorized from './Unauthorized';
import { withRenderTracking } from '../Components/Tracked/withMixpanelTracking';
import { TrackableEvents } from '../Components/Tracked/events';
import { UserRoles } from '../Constants/Constants';
import PermissionGate from '../Components/Shared/PermissionGate';

const TrackedPage = withRenderTracking(Page)(TrackableEvents.PageViewed, { page_name: 'Air Quality' });

export function AirQuality() {
  const { data: sensors } = useAirQualitySensorsQuery();

  return (
    <PermissionGate
      allowedRoles={[UserRoles.SuperAdmin, UserRoles.Admin, UserRoles.AssistantAdmin]}
      fallback={<Unauthorized />}>
      <TrackedPage
        docTitle='Air Quality'
        title={
          <Typography variant='h3' color='textPrimary' noWrap>
            Air Quality
          </Typography>
        }>
        {sensors && <AirQualityTable data={sensors} />}
      </TrackedPage>
    </PermissionGate>
  );
}
